"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockSalesOrderRefunds = exports.mockSerializedSalesOrderRefunds = void 0;
const mockSalesOrderItems_1 = require("./mockSalesOrderItems");
const currentUnixTimestamp_1 = require("../../../../../../apis/spg/util/currentUnixTimestamp");
const guid_1 = require("../../../../../../apis/spg/util/guid");
const IPromotion_1 = require("../../../types/IPromotion");
const SalesOrderRefund_1 = require("../../../models/SalesOrderRefund");
exports.mockSerializedSalesOrderRefunds = [
    {
        salesOrderRefundId: (0, guid_1.createGuid)(),
        comment: "Not what was ordered.",
        overridePrice: null,
        createdAt: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        updatedAt: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        user: null,
        salesOrderRefundProducts: [
            {
                product: mockSalesOrderItems_1.mockSerializedBuiltSalesOrderItems[0],
                quantity: 1
            }
        ],
        salesOrderRefundPromotions: [
            {
                promotion: {
                    description: "10% off all standard drinks",
                    priceDiscounted: 1.2,
                    type: IPromotion_1.TPromotionType.Item
                },
                quantity: 1
            }
        ]
    }
];
exports.mockSalesOrderRefunds = exports.mockSerializedSalesOrderRefunds.map((salesOrderRefund) => {
    const salesOrderRefundModel = SalesOrderRefund_1.SalesOrderRefund.unserialize(salesOrderRefund);
    return salesOrderRefundModel;
});
//# sourceMappingURL=mockSalesOrderRefunds.js.map